<app-navbar *ngIf="!isLoading"></app-navbar>

<div class="home-container">
  <div class="home">
    <p>Choose a mode and upload your files to get started.</p>
  </div>

  <app-upload-form
   [receivedFile]="fileFromPopup"
   (openPopup)="openPopup()"
   (loadingStateChange)="onLoadingStateChange($event)"
   >
  </app-upload-form> <!-- Listen for event -->
</div>

<app-pop-up [isOpen]="isPopupOpen"
(popupClosed)="closePopup()"
(processedFileEmitted)="handleProcessedFile($event)"
></app-pop-up>>

<app-loader *ngIf="isLoading"></app-loader>
<app-chatBot></app-chatBot>







